<template>
    <div>
        <div class="ajFlex c-page-top">
            <div class="c-page-title">修改企业用户</div>
            <Button type="info" ghost @click="handleBack">返回</Button>
        </div>
        <div class="form-list form-wrapper">
            <Button class="long-addBtn" size="large" long type="dashed" :loading="loading" @click="handleSubmit('formInline')">确认提交</Button>
            <Form class="form-list" ref="formInline" :model="formInline" :rules="ruleInline" inline :label-width="150" label-position="right">
                <Row>
                    <Col span="12" offset="4">
                        <FormItem prop="creditCode">
                            <div slot="label" style="display: inline-block">
                                <span>统一社会信用代码</span>
                                <div style="color: #ff3300">（登录用户名）</div>
                            </div>
                            <Input v-model="formInline.creditCode" size="large" type="tel" placeholder="请输入统一社会信用代码"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12" offset="4">
                        <FormItem label="企业名称" prop="name">
                            <Input v-model="formInline.name" size="large" placeholder="请输入企业名称"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12" offset="4">
                        <FormItem label="注册属地" prop="address_codeS">
                            <Cascader :clearable="false" :data="areas" size="large"
                                      @on-change="handleAdress"
                                      v-model="formInline.address_codeS" placeholder="请选择"></Cascader>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12" offset="4">
                        <FormItem label="联系人" prop="linkPerson">
                            <Input v-model="formInline.linkPerson" size="large" placeholder="请输入联系人"></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12" offset="4">
                        <FormItem label="联系电话" prop="linkPersonTel">
                            <Input v-model="formInline.linkPersonTel" type="tel"  size="large" placeholder="请输入联系电话"></Input>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        </div>
    </div>
</template>
<style scoped>

</style>
<script>
    import { mapState, mapActions } from 'vuex';
    export default {
        components: {

        },
        data(){
            const validateLogin = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请填写统一信用代码!'));
                } else {
                    this.axios({
                        method: 'get',
                        url: '/register/checkAccountExist',
                        params: {
                            account:value,
                            id:this.id,
                        },
                    }).then( (response) =>{
                        if(response.data){
                            callback(new Error('该统一信用代码已经存在!'));
                        }else {
                            callback();
                        }
                    });
                }
            };
            const validatePhone = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请填写联系电话!'));
                } else {
                    this.axios({
                        method: 'get',
                        url: '/register/checkMobileExist',
                        params: {
                            mobile:value,
                            id:this.id,
                        },
                    }).then( (response) =>{
                        if(response.data){
                            callback(new Error('手机号已经存在!'));
                        }else {
                            callback();
                        }
                    });
                }
            };
            return {
                id:'',
                userType:'',
                loading: false,
                formInline: {
                    creditCode: '',
                    name: '',
                    address_codeS: [],
                    regPlaceCode: '',
                    regPlace: '',
                    linkPerson: '',
                    linkPersonTel: '',
                },
                ruleInline: {
                    creditCode: [
                        { required: true, validator: validateLogin, trigger: 'blur' },
                    ],
                    name: [
                        { required: true, message: '企业名称不能为空',  trigger: 'blur' }
                    ],
                    address_codeS: [
                        { required: true, type:'array', min: 1, message: '注册属地不能为空', trigger: 'change' }
                    ],
                    linkPerson: [
                        { required: true, type:'string',  message: '联系人不能为空', trigger: 'blur' }
                    ],
                    linkPersonTel: [
                        { required: true, type:'string',  message: '联系电话不能为空', trigger: 'blur' },
                        { pattern: /^1(3|4|5|6|7|8|9)\d{9}$/, message: '手机号不正确', trigger: 'change' },
                        { required: true, validator: validatePhone, trigger: 'blur' },
                    ],
                },
            };
        },
        computed:{
            ...mapState(['areas']),
        },
        created(){
            this.GetAreas();
            this.id= this.$route.query.id;
            this.userType= this.$route.query.userType;
            this.getPageData();
        },
        mounted(){

        },
        watch: {

        },
        methods: {
            ...mapActions(['GetAreas']),
            /* 获取页面信息 */
            getPageData(){
                // 获取页面信息
                this.axios({
                    method: 'get',
                    url:'/user/getUserById',
                    params:{
                        id:this.id,
                        userType:this.userType,
                    }
                }).then((response)=>{
                    if(response.data.success){
                        if(response.data.data.regPlaceCode){
                            response.data.data.address_codeS=response.data.data.regPlaceCode.split('-');
                        }
                        this.formInline=response.data.data;
                    }
                });
            },
            handleAdress(value,selectedData){
                let larr=[];
                let varr=[];
                selectedData.forEach(item=>{
                    larr.push(item.label);
                    varr.push(item.value);
                });
                this.formInline.regPlace=larr.join('-');
                this.formInline.regPlaceCode=varr.join('-');
            },
            // 返回
            handleBack(){
                this.$router.go(-1);
            },
            // 提交
            handleSubmit(name){
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        let data={};
                        Object.assign(data,this.formInline);
                        data.id = this.id;
                        this.loading=true;
                        this.axios({
                            method: 'post',
                            url: '/sublet/modify',
                            data: data,
                        }).then((response) => {
                            this.loading=false;
                            if(response.data.success){
                                this.$Message.success('提交成功!');
                                this.$router.go(-1);
                            }else {
                                this.$Message.warning(response.data.message);
                            }
                        }).catch( ()=> {
                            this.loading=false;
                        });
                    } else {
                        this.$Message.error('表单验证未通过!');
                    }
                });
            }
        }
    };
</script>
